export default function regionComparator(a, b) {
    /*
     unconstrained, future in chron, past in rev chron
     */
    if (a.when && !b.when) return 1;
    if (b.when && !a.when) return -1;
    if (!a.when && !b.when) return 0;
    const now = Date.now();
    const af = a.when > now;
    const bf = b.when > now;
    if (af && bf) return a.when - b.when;
    if (!af && !bf) return b.when - a.when;
    return af ? -1 : 1;
};


// WEBPACK FOOTER //
// ./src/util/regionComparator.js